export const VERASO_LOGO = "/brand/veraso-logo.png";

/**
 * Wordmark — the canonical "Veraso Reports" text logo.
 *
 * "Veraso" in brand-blue, "Reports" in emerald. Used everywhere the
 * brand needs a clean type-only mark (login, register, app shell,
 * marketing footers). No image dependency — scales crisply.
 *
 * Props:
 *   size: "sm" | "md" | "lg" — controls font size
 *   className: extra Tailwind utilities to compose with
 */
export function Wordmark({ size = "md", className = "" }) {
  const sizes = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl",
  };
  return (
    <span
      className={`font-display font-bold tracking-tight inline-flex items-baseline gap-1 ${sizes[size] || sizes.md} ${className}`}
      data-testid="veraso-wordmark"
    >
      <span className="text-blue-900">Veraso</span>
      <span className="text-emerald-600">Reports</span>
    </span>
  );
}

/**
 * Default export keeps the old `<Logo />` API alive but now renders the
 * wordmark instead of the raster logo. Callers that imported the image
 * URL directly via `VERASO_LOGO` still work.
 */
export default function Logo({ size = "md", className = "" }) {
  return <Wordmark size={size} className={className} />;
}
